import { FetchClient } from '../types'
import { ClientSessionResponse, SurveyData } from './types'

const BASE_PREFIX = `/api/truework-js/client/session`

export const clientSessionEndpoints = (fetchClient: FetchClient) => {
  return {
    async getClientSession() {
      return fetchClient<ClientSessionResponse>(BASE_PREFIX)
    },
    async gatherSessionConsent() {
      return fetchClient<ClientSessionResponse>(`${BASE_PREFIX}/consent`, { method: 'POST' })
    },
    async configureSession(publishableKey: string) {
      return fetchClient<ClientSessionResponse>(`${BASE_PREFIX}/configure`, {
        method: 'POST',
        body: JSON.stringify({ publishable_key: publishableKey }),
      })
    },
    async manuallyTriggerIES() {
      return fetchClient<ClientSessionResponse>(`${BASE_PREFIX}/advance_to_ies`, { method: 'POST' })
    },
    async submitEndSurveyResult(surveyData: SurveyData) {
      return fetchClient<ClientSessionResponse>(`${BASE_PREFIX}/submit_end_survey_result`, {
        method: 'POST',
        body: JSON.stringify(surveyData),
      })
    },
    async completeSession() {
      return fetchClient<ClientSessionResponse>(`${BASE_PREFIX}/complete`, { method: 'POST' })
    },
  }
}
